import * as React from "react";
import { useTranslation } from "react-i18next";
import { useCallback, useState } from "react";
import i18n from "i18n";
import { Button } from "components/bootstrap";
import { IfPermitted, ShareButton } from "components/common";
import EntityShareModal from "components/permissions/EntityShareModal";
import useSelectedEntities from "components/common/EntityDataTable/hooks/useSelectedEntities";
import { useTableFetchContext } from "components/common/PaginatedEntityTable";
import useGetPermissionsByScope from "hooks/useScopePermissions";
const onDelete = (e, savedSearch, deleteSavedSearch, activeSavedSearchId, refetch, deselectEntity) => {
  e.stopPropagation();
  if (window.confirm(i18n.t("saved_searches.confirm_delete", { ns: "search", title: savedSearch.title }))) {
    deleteSavedSearch(savedSearch).then(() => {
      if (savedSearch.id !== activeSavedSearchId) {
        refetch();
      }
      deselectEntity(savedSearch.id);
    });
  }
};
const SearchActions = ({ search, onDeleteSavedSearch, activeSavedSearchId }) => {
  const { t } = useTranslation("search");
  const { deselectEntity } = useSelectedEntities();
  const { refetch } = useTableFetchContext();
  const [showShareModal, setShowShareModal] = useState(false);
  const { scopePermissions } = useGetPermissionsByScope({ _scope: search.scope });
  const toggleEntityShareModal = useCallback(() => {
    setShowShareModal((cur) => !cur);
  }, []);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ShareButton, { bsSize: "xsmall", entityId: search.id, entityType: "search", onClick: () => setShowShareModal(true) }), (scopePermissions == null ? void 0 : scopePermissions.is_mutable) && /* @__PURE__ */ React.createElement(IfPermitted, { permissions: [`view:edit:${search.id}`, "view:edit"], anyPermissions: true }, /* @__PURE__ */ React.createElement(
    Button,
    {
      onClick: (e) => onDelete(e, search, onDeleteSavedSearch, activeSavedSearchId, refetch, deselectEntity),
      role: "button",
      bsSize: "xsmall",
      bsStyle: "danger",
      title: t("saved_searches.delete_search", { title: search.title }),
      tabIndex: 0
    },
    t("saved_searches.delete")
  )), showShareModal && /* @__PURE__ */ React.createElement(
    EntityShareModal,
    {
      entityId: search.id,
      entityType: "search",
      entityTitle: search.title,
      description: t("save_form.share_description"),
      onClose: toggleEntityShareModal
    }
  ));
};
export default SearchActions;
